module.exports = true;


/*****************
 ** WEBPACK FOOTER
 ** /home/onlygamescl/onlygames-front/shared/~/core-js/library/modules/_library.js
 ** module id = 30
 ** module chunks = 1
 **/